import { ITemplate } from 'shared/interfaces'
import { CAMPAIGN_INFO_TEMPLATE, TEAM_TEMPLATE } from 'modules/Labels/constants/editorOptions'
import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'
import { formatProjectInfo } from 'shared/utils/quillForm'
import { ITypeForm, TForm } from '../components/TableFormList/TableFormList.props'
import { LabelTemplateType } from 'shared/__gql-types'

export const isUniqueFieldValue = <T extends Record<string, any>>(item: T, value: ITypeForm<TForm>[], field: string) =>
  !value.find((el: ITypeForm<TForm>) => el.id !== item.id && (el as any)[field].toLowerCase() === item[field].toLowerCase())

export const rulesUnitsOptions =
  <T extends Record<string, any>>(field: string, fieldParam: string) =>
    (array: T[], id: string) => ({
      required: `${field} Name is required.`,
      validate: (value: string) =>
        array.find((el: T) => el.id !== id && el[fieldParam] === value) && `${field} Name should be unique`
    })
export const mergeDefaultValue = (templateDefault: ITemplate[], templateList: ITemplate[], id?: string) =>
  templateDefault.map(
    (val) =>
      templateList.find((temp) => temp.template_type === val.template_type) || {
        ...val,
        ...(id && { label_id: Number(id) })
      }
  )

export const setInitialData = (isCampaign: boolean, initialData: string | undefined) => {
  const template = isCampaign ? CAMPAIGN_INFO_TEMPLATE : TEAM_TEMPLATE

  return initialData ? formatProjectInfo(initialData) : template
}

export const fieldNameToLabel = (fieldName: string) => {
  const updatedFieldName = fieldName.includes('campaign') ? fieldName.replace('campaign', 'project') : fieldName

  return capitalizeFirstLetter(updatedFieldName.replace('_', ' '))
}

export const getTemplateTitle = (type: LabelTemplateType, isGlobal?: boolean) => {
  if (type === LabelTemplateType.TeamInfo) return `${isGlobal ? 'Global' : 'Local'} Team Information`
  if (type === LabelTemplateType.CampaignInfo) return `${isGlobal ? 'Global' : 'Local'} Project Information`
}
